import React, { Component } from 'react'
import styled from 'styled-components';

import { Button } from './Button';
import { Input } from './Input';

const FilterWrapper = styled.div`
  width: 100%;
  padding: 5px;
  & input {
    margin-bottom: 5px;
  }
`;
export class SearchFilter extends Component {
  constructor(props) {
    super(props);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      value: '',
    };
  }

  handleValueChange(e) {
    this.setState({value: e.target.value});
  }
  handleSubmit() {
    this.props.onSubmit(this.state, this.props.label);
  }

  render() {
    const {value} = this.state;
    const {label} = this.props;

    return (
      <FilterWrapper>
        <Input
          onChange={this.handleValueChange}
          placeholder={label.replace(/_/g, ' ')}
          type='text'
          value={value}
        />
        <Button
          block
          onClick={this.handleSubmit}
        >
          FILTER
        </Button>
      </FilterWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchFilter.js